import {
  FiSmartphone,
  FiUserCheck,
  FiMonitor,
  FiShield,
  FiUsers,
} from 'react-icons/fi';

const features = [
  {
    Icon: FiSmartphone,
    title: 'WhatsApp-First Signing',
    desc: 'Signers receive and complete the entire signing flow inside WhatsApp. No app downloads or account creation required.',
  },
  {
    Icon: FiUserCheck,
    title: 'Aadhaar eSign Workflows',
    desc: 'Legally valid Aadhaar OTP-based electronic signatures for compliant, citizen-friendly experiences.',
  },
  {
    Icon: FiMonitor,
    title: 'DSC Desktop Signer',
    desc: 'Windows and Mac application for USB DSC token signing without complicated setup or driver headaches.',
  },
  {
    Icon: FiShield,
    title: 'Evidence Vault',
    desc: 'Immutable, court-admissible evidence packets generated automatically at signing time.',
  },
  {
    Icon: FiUsers,
    title: 'Team Workflows',
    desc: 'Multi-party signing, approval chains, and role-based access for your entire organization.',
  },
];

export default features;
